"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Root = void 0;
var _mui = require("@ori-ui/mui");
var _constants = require("../GenesysSupportCenterSkeleton/constants");
/* eslint-disable @typescript-eslint/naming-convention -- CSS syntax conflict */ const getSecondaryButtonStyles = function(theme) {
    let size = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'medium';
    return {
        backgroundColor: theme.palette.common.white,
        border: "1px solid ".concat(theme.palette.default.dark),
        borderRadius: theme.spacing(5),
        color: theme.palette.default.dark,
        fontWeight: theme.typography.fontWeightBold,
        height: 'unset',
        padding: theme.spacing(2, size === 'small' ? 4 : 5),
        textTransform: 'uppercase',
        width: 'unset',
        // Text inside button
        span: {
            color: theme.palette.default.dark,
            fontSize: size === 'small' ? '1.3rem !important' : '1.4rem !important'
        },
        // Icon inside button
        svg: {
            fill: theme.palette.default.dark,
            height: 16,
            width: 16
        },
        '&:not(:disabled)': {
            '&:hover': {
                backgroundColor: theme.palette.grey[200]
            }
        }
    };
};
const getPrimaryButtonStyles = (theme)=>({
        ...getSecondaryButtonStyles(theme),
        backgroundColor: theme.palette.default.dark,
        color: theme.palette.common.white,
        // Text inside button
        span: {
            color: theme.palette.common.white
        },
        // Icon inside button
        svg: {
            fill: theme.palette.common.white
        },
        '&:not(:disabled)': {
            '&:hover': {
                backgroundColor: theme.palette.grey.A700
            }
        }
    });
// List of links to articles on category page and search results page
const getListStyles = (theme)=>({
        gap: 0,
        li: {
            borderTop: "1px solid ".concat(theme.palette.grey[100]),
            gap: 0,
            padding: 0,
            width: '100%',
            '&:last-of-type': {
                borderBottom: "1px solid ".concat(theme.palette.grey[100])
            },
            '&:hover': {
                boxShadow: 'unset'
            },
            // Title with link
            a: {
                boxShadow: 'unset',
                padding: theme.spacing(3, 0),
                span: {
                    ...theme.typography.h6,
                    display: '-webkit-box',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: 2,
                    whiteSpace: 'normal'
                },
                // Text inside link
                '&:hover': {
                    backgroundColor: 'unset',
                    span: {
                        color: theme.palette.text.hover,
                        textDecoration: 'underline'
                    }
                }
            }
        }
    });
/**
 * Styles to override styling of the Genesys Support Center components.
 */ const Root = exports.Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        fontFamily: 'SansOri, SansOriFallback, sans-serif',
        // All inputs, e.g. search input
        input: {
            fontSize: '1.6rem',
            color: theme.palette.text.primary,
            lineHeight: 1.5,
            paddingTop: theme.spacing(2)
        },
        // Titles in top banner and search results page
        h1: theme.typography.h3,
        // Titles in category and article page
        h2: theme.typography.h5,
        // Standard text restyling in articles and categories
        // important is used to override <span style>
        'span, p': {
            // We do not want to change background color of skeletons
            ["&:not(.".concat(_constants.GENESYS_SUPPORT_CENTER_SKELETON, ")")]: {
                backgroundColor: 'inherit !important'
            },
            // We do not want to change size of links in category page and search results page
            ["&:not([class*=CategoryArticle_categoryArticleTitle_], [data-testid=knowledge-result-item-text])"]: {
                fontSize: '1.6rem !important'
            },
            color: theme.palette.text.primary,
            lineHeight: 1.5
        },
        // Sticky top banner with search input is visible when scrolled down and original top banner is not visible
        'div[class*=KnowledgeSearch_stickyMainContainer_]': {
            top: 'var(--top-nav-height)'
        },
        // Container with padding around search input and main title
        "div[class^='KnowledgeSearch_container__']": {
            padding: theme.spacing(6, 0)
        },
        // Inner container with content that limits maxWidth
        'div[class*=Containers_innerContainer_]': {
            maxWidth: 'calc(min(100%, 1014px))',
            [theme.breakpoints.up('sm')]: {
                maxWidth: 'calc(min(100%, 1064px))'
            }
        },
        // Search input in main container
        'div[class*=SearchField_container_]': {
            boxShadow: 'unset',
            '&:focus-within': {
                outline: "2px solid ".concat(theme.palette.primary.main)
            }
        },
        // Search icon in search input
        'button[class*=IconButton_iconButton_]': {
            marginTop: theme.spacing(1),
            svg: {
                fill: theme.palette.text.primary,
                width: 16
            }
        },
        // We want to hide divider in search results page
        'hr[class*=KnowledgeResults_results_divider_]': {
            display: 'none'
        },
        // Count of search results in search results page
        '[data-testid=knowledge-results-details]': {
            marginBottom: theme.spacing(4)
        },
        // Item in list of search results under search input
        'button[class*=AutocompleteItem_container_]': {
            '&:hover': {
                backgroundColor: theme.palette.primary.light
            }
        },
        // Container containing Title in Search results page
        'div[class*=KnowledgeResults_results_headerContainer_]': {
            paddingLeft: 0
        },
        // Title in Search results page
        '[data-testid=knowledge-results-title]': theme.typography.h5,
        // Breadcrumbs
        "[data-testid='breadcrumb-container']": {
            margin: theme.spacing(0, 0, 2)
        },
        // Wrapper of Link (Category box) to category on landing page
        'div[class*=CategoryGridItem_categoryGridItemContainer_]': {
            flex: '0 0 auto',
            padding: 0,
            margin: 0,
            width: '100%',
            [theme.breakpoints.up('sm')]: {
                width: 234
            }
        },
        // Link (Category box) to category on landing page
        'a[class^=CategoryGridItem_categoryGridItem_]': {
            backgroundColor: theme.palette.green[50],
            borderRadius: theme.shape.borderRadius,
            boxShadow: 'unset',
            height: 110,
            outline: "1px solid ".concat(theme.palette.grey[500]),
            padding: theme.spacing(3, 2),
            width: '100%',
            '&:hover': {
                backgroundColor: theme.palette.primary.main
            },
            '&:focus-within': {
                outline: "2px solid ".concat(theme.palette.primary.main)
            }
        },
        // Category Box content
        'div[class*=CategoryGridItem_categoryGridItemContent_]': {
            alignItems: 'center',
            gap: theme.spacing(1)
        },
        // Category box image on landing page
        'img[class*=CategoryGridItem_categoryGridItemImage_]': {
            height: 32,
            margin: 0,
            width: 32
        },
        // Category box title on landing page
        'span[class*=CategoryGridItem_categoryGridItemTitle_]': {
            ...theme.typography.h6,
            display: '-webkit-box',
            lineHeight: 1.4,
            margin: 0,
            padding: 0,
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,
            whiteSpace: 'normal',
            [theme.breakpoints.up('md')]: {
                lineHeight: 1.4
            }
        },
        // List of links to articles on category page
        'ul[data-testid=articles-container]': getListStyles(theme),
        // Info box in empty category page
        'div[class*=CategoryEmpty_categoryEmptyCard_]': {
            boxShadow: 'unset',
            maxWidth: '100%'
        },
        // Content of info box in empty category page
        'div[class*=CategoryEmpty_categoryEmptyContent_]': {
            maxWidth: '100%'
        },
        // Title in info box in empty category page
        'h1[class*=CategoryEmpty_categoryEmptyTextHeader_]': theme.typography.h6,
        // Pagination buttons on category page
        '[data-testid=pagination-button-previous], [data-testid=pagination-button-next]': getSecondaryButtonStyles(theme),
        // Loader container
        'div[class^=Loaders_container_]': {
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            padding: theme.spacing(12, 0, 20),
            p: {
                color: theme.palette.text.primary,
                lineHeight: 1.5,
                fontSize: '1.6rem',
                marginTop: theme.spacing(1)
            },
            [theme.breakpoints.up('sm')]: {
                padding: theme.spacing(20, 0, 36)
            }
        },
        // Loader
        '[class*=Loaders_loader_]': {
            margin: 0,
            '&:before': {
                backgroundColor: theme.palette.primary.main
            },
            '[class*=Loaders_svg_]': {
                circle: {
                    stroke: theme.palette.primary.main
                }
            }
        },
        // Article container
        'div[class*=KnowledgeArticle_container_]': {
            padding: 0
        },
        // Article body container
        'div[class*=KnowledgeArticle_bodyContainer_]': {
            marginBottom: theme.spacing(8)
        },
        // Image in article page
        'img[class*=ArticleElements_articleImage_]': {
            width: 'auto'
        },
        // Divider in all pages except divider in search input autocomplete (.undefined)
        hr: {
            '&:not(.undefined)': {
                margin: theme.spacing(4, 0)
            }
        },
        // Used by top banner wrapper and content wrapper components
        '.gc-row': {
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            gap: theme.spacing(3),
            margin: 0,
            justifyContent: 'center',
            alignItems: 'center'
        },
        // Used by top banner and component wrapper component
        'div[class^=Containers_mainContainer]': {
            padding: 0
        },
        // Container that includes background color of content
        'main[class*=SupportCenter_container_]': {
            backgroundColor: theme.palette.common.white
        },
        // Higher z-index collides with our dialogs and popups
        '#mainContainer': {
            zIndex: 0
        },
        // List of search result items
        '[data-testid=knowledge-result-list]': getListStyles(theme),
        // Description in search result item
        '[data-testid=knowledge-result-item-content]': {
            display: '-webkit-box',
            marginBottom: theme.spacing(3),
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,
            whiteSpace: 'normal'
        },
        // We want to hide publication date in article and search results
        '[data-testid=article-last-updated], div[class*=KnowledgeResultItem_resultItemDetails_]': {
            display: 'none'
        },
        // Feedback container in article
        'div[class*=ArticleFeedback_container_]': {
            backgroundColor: theme.palette.grey[100],
            boxShadow: 'unset',
            marginBottom: theme.spacing(2),
            padding: theme.spacing(3)
        },
        // Feedback title in article
        '[class*=ArticleFeedback_heading_]': theme.typography.h6,
        // Feedback description in article, we want to hide it
        '[class*=ArticleFeedback_text_]': {
            display: 'none'
        },
        // Feedback buttons in article under "Did this answer your question?" title
        'button[class*=ArticleFeedback_feedbackBtn__]': getSecondaryButtonStyles(theme, 'small'),
        // Clicked positive feedback button in article under "Did this answer your question?" title
        'button[class*=ArticleFeedback_selectedButtonPositive_]': {
            backgroundColor: theme.palette.primary.main
        },
        // Clicked negative feedback button in article under "Did this answer your question?" title
        'button[class*=ArticleFeedback_selectedButtonNegative_]': {
            backgroundColor: theme.palette.error.main
        },
        // Title in dialog after click on negative feedback button in article under "Did this answer your question?" title
        '[class*=ArticleFeedback_title_]': {
            color: theme.palette.text.primary,
            fontSize: '1.6rem',
            fontWeight: theme.typography.fontWeightBold,
            marginRight: theme.spacing(3)
        },
        // Textarea in dialog after click on negative feedback button in article under "Did this answer your question?" title
        'textarea[class*=ArticleFeedback_textarea_]': {
            backgroundColor: theme.palette.common.white,
            '&:focus-within': {
                outline: "1px solid ".concat(theme.palette.primary.main)
            }
        },
        // Submit button in dialog after click on negative feedback button in article under "Did this answer your question?" title
        'button[class*=ArticleFeedback_submitfeedbackButton_]': getPrimaryButtonStyles(theme),
        // Breacrumbs on category and article pages
        ".breadcrumbLink, li[class^='BreadCrumb_breadcrumbListItem_'], li[class^='BreadcrumbContainer_breadcrumbListItem_']": {
            color: theme.palette.text.primary
        },
        // Add border to tables in articles
        'table[class^=ArticleElements_articleTable_]': {
            border: "1px solid ".concat(theme.palette.text.primary),
            'th, tr, td': {
                border: "1px solid ".concat(theme.palette.text.primary)
            }
        },
        // Error message
        '[class*=ErrorCard_container_]': {
            boxShadow: 'unset'
        },
        '.sm-margin-b-4': {
            marginBottom: theme.spacing(2),
            width: '100%'
        },
        '.sm-margin-b-6': {
            marginBottom: theme.spacing(6)
        },
        '.md-offset-1': {
            marginLeft: 0
        },
        '.md-offset-2': {
            marginLeft: 0
        },
        '.md-col-10, .md-col-8': {
            flex: '0 0 100%',
            padding: theme.spacing(0, 3),
            [theme.breakpoints.up('sm')]: {
                padding: theme.spacing(0, 8)
            }
        },
        '.lg-col-8': {
            flex: '0 0 100%'
        },
        '.lg-offset-2': {
            marginLeft: 0
        },
        '.lg-offset-3': {
            marginLeft: 0
        }
    };
});
